import React, { useContext } from 'react';
import { ShopperContext } from '../context/shopper';
import { useParams, useNavigate } from 'react-router-dom';
import { BackButton } from './BackButton';
import { HeadingBuilder } from './HeadingBuilder';
import { useTranslation } from "react-i18next";
import * as Constants from '../constants';
import YesOrNoQs from './YesOrNoQs';
import { usePhrasing } from "../hooks/useSkuUtils";

export const SubscriptionDeleteForm = () => {
    const { signedIn, shopper, circles, circleShoppers,
            deleteSubscription } = useContext(ShopperContext);
    console.log('sdf circleShoppers: ', circleShoppers)

    const navigate = useNavigate();

    const {circle_id, id} = useParams();
    console.log('sdf circle_id: ', circle_id)
    console.log('sdf id: ', id)

    const { t } = useTranslation();
    const { getWithdrawTheQuestionTippyContent } = usePhrasing();

    const circleObj = circles.find(c =>  c.id === circle_id);
    console.log('sdf circleObj: ', circleObj)

    if (circleObj.subscription.id !== id) {
      console.log('sdf id, circleObj: ', id, circleObj)
      // User likely used browser to refresh the page, lost access to state.
      // Let's go back to the 'circles' page.
      window.location.replace('/circles/');
    }

    async function removeSubscription (e) {
      // TODO: is event (e) useful for anything?
  
      // Delete a subscription.
      // Backend only allows circle's leader to delete a subscription.
  
      console.log("sdf before di", Date.now() );
      const rc = await deleteSubscription(id);
      console.log("sdf rc", rc);
      console.log("sdf after dt", Date.now() );
  
      // 250613 - same as note below: This code is mostly copy/paste.
      // Domments seem plausible for doing the same here.

      // Now that we have deleted a subscription, e.g. id 51, this url has no
      // subscription to delete:
      // http://localhost:4000/circles/534/subscriptions/51/delete
      // We see error messages complaining about not finding that id.
      // Instead of letting that happen, let's navigate to safer ground:
      navigate('/circles/', {replace: true});

      // Refresh to update state, make sure future activity doesn't present
      // the deleted subscription.
      navigate(0);
      // The effect is clumsy. It takes a long time and it's not intuitive why
      // we did not land back on the '/circles/' page.

      // 250613 - Note: I had copied this code from 'TripDeleteForm' and have
      // not really tested for this condition. I'm leaving it in because it
      // shouldn't hurt, but maybe it's unnecessary.
      //
      // I would have thought this line would cause the browser to start
      // showing '/circles/' but the view remains fixed at '/'.
      // And yet without this line, we see an ugly error upon clicking a Back
      // button. (We have just deleted a subscription so that going to a url
      // for a nonexistent subscription fails.)
      // Helpfully, if shopper clicks Back while now viewing '/', this line 
      // causes the '/circles/' view to display.
      navigate('/circles/', {replace: true});
    }

    const shopper_is_circle_leader =  circleObj.leader_id === shopper.id

    const removeSubscriptionHeadComment =
        t('subscription.removeSubscription.tippyContentAYSHead')
      + ' // '
      + t('subscription.removeSubscription.tippyContentB')

    const removeSubscriptionButtonComment =
        t('subscription.removeSubscription.tippyContentAYSButton')
      + ' // '
      + t('subscription.removeSubscription.tippyContentB')

    if (signedIn && shopper_is_circle_leader) {
      return (
        <article>
          <HeadingBuilder
            Size        = 'h3'
            headingText = {t('subscription.formPart.headlineDeleteSubscription')}
            value       = {circleObj.identifier}
            // Delete Subscription for Circle: js02
          />
          <br/>
          <br/>
          <HeadingBuilder
            Size = 'h1'
            headingText    = {t('global.areYouSure')}
            // Are You Sure?
            tippyAlertText = {removeSubscriptionHeadComment}
            tippyText      = {Constants.DOT}
          />
          <YesOrNoQs
            headingTextYes    = {t('subscription.removeSubscription.label')}
            // Yes, cancel Subscription
            buttonActionYes   = {removeSubscription}
            tippyAlertTextYes = {removeSubscriptionButtonComment}

            headingTextNo     = {t('subscription.removeSubscription.labelNo')}
            // No, don't cancel Subscription
            tippyAlertTextNo  = {getWithdrawTheQuestionTippyContent({
                                  object_name: t('global.label.subscription')
                                })}
          />
          <br/>
          <BackButton />
        </article>
      )
    } else {
      return (
        <HeadingBuilder
          Size = 'h3'
          headingText = {t('global.notSignedInMessage')}
          // Not Authorized - Please Sign in or Sign up
        />
      )
    }
}

export default SubscriptionDeleteForm;